import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {zaunspitzen} from '../../../../../assets/images/data';
import {updateZaunspitzen, updateStepsZaun} from '../../../../store/actions/zaune';
import scrollToElement from '../../../../module/scrollToElement';

const Step_4 = (props) => {

   let [is_zaunspitzen, updateIsZaunspitzen] = useState(true);

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      let spitzenWrapper = document.querySelectorAll('.spitzenWrapper');
      const {spitze, index} = props.data.spitzen[0];
      const {titel} = props.data.modell[0];

      for (let i = 0; i < spitzenWrapper.length; i++) {
         spitzenWrapper[i].classList.remove('check');
       }

      if(spitze && spitzenWrapper[index]) {
         spitzenWrapper[index].classList.add('check');
         //scroll to Next Button Container
         scrollToElement();
      }

      if (titel === 'Modell - 1104C' ||
         titel === 'Modell - 1208M' ||
         titel === 'Modell - 1209M' ||
         titel === 'Modell - 1210M') {
         updateIsZaunspitzen(false);
         props.updateZaunspitzen("Keine Spitzen");
      } else {
         updateIsZaunspitzen(true);
      }

      //update steps
      props.updateSteps(3);
      if (spitze || !is_zaunspitzen) props.updateSteps(4);

      //update titel of spitze
      if (!is_zaunspitzen)  props.updateZaunspitzen({titel:'Keine Spitzen', index: 0});

      //Weiter-Button aktivieren
      if (spitze || !is_zaunspitzen || props.data.allVisitedSteps) {
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue();
      }

   }

   const selectItem = ev => {
      let titel = ev.currentTarget.getAttribute('titel');
      let index = ev.currentTarget.getAttribute('index');
      let zaunSpitzenObject = {
         titel: titel,
         index: index
      }
      props.updateZaunspitzen(zaunSpitzenObject);
      updateItems();
   }

       return (
         <div className="step_wrapper">
         {is_zaunspitzen?
         <>
          <h2 className="step_header">Benötigen Sie Zaunspitzen?</h2>
            <div className="step_icon_wrapper">
               <div className="inner-spitzen-wrapper">
                     {zaunspitzen.map((elem, index) => (
                        <div className="spitzenWrapper" onClick={selectItem} key={index} index={index} titel={elem.titel}>
                           {elem.titel === "Keine Spitzen" ? <p style={{margin: "55px 0"}}>keine Spitzen</p>
                           :
                           <img src={elem.img} alt={elem.titel} />}
                        </div>
                     ))}
               </div>
            </div>
            </>
         : <h2 className="step_header">Dieses Modell enthält keine Zaunspitzen</h2>
         }
      </div>
       )
}

const mapStateToProps = state => {
    return {
      data: state.zauneReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateZaunspitzen: ev => dispatch(updateZaunspitzen(ev)),
      updateSteps: ev => dispatch(updateStepsZaun(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_4);
